<template>
  <div class="text-center">
<!-- Titlu și descriere -->
<h2 class="text-primary fw-bold mb-3">
  <i class="fas fa-terminal me-2"></i> {{ $t('home.greeting') }}
</h2>
<p class="lead text-white fs-5 mb-4" style="font-family: 'Fira Code', monospace;">
  {{ $t('home.description') }}
</p>

<!-- Butoane -->
<!-- Butoane -->
<div class="mt-3 d-flex flex-wrap justify-content-center gap-3">
  <router-link
    to="/portfolio"
    class="btn btn-outline-primary px-4 py-2 d-flex align-items-center gap-2"
  >
    <i class="fas fa-briefcase"></i> {{ $t('home.viewPortfolio') }}
  </router-link>

  <router-link
    to="/contact"
    class="btn btn-outline-primary px-4 py-2 d-flex align-items-center gap-2"
  >
    <i class="fas fa-paper-plane"></i> {{ $t('home.contactMe') }}
  </router-link>
</div>


  <h3 class="text-primary fw-bold mb-2 mt-4">
    <i class="fas fa-cogs me-3"></i>{{ $t('home.skills.title') }}</h3>
<div class="d-flex flex-wrap justify-content-center gap-3 mb-4 mt-4">

<button
  v-for="cat in categoryList"
  :key="cat.key"
  class="badge bg-dark"
  @click="selectedCategory = selectedCategory === cat.key ? null : cat.key"
>
  <Icon :icon="cat.icon" width="22" height="22" style="color: white" />
  {{ $t(`home.categories.${cat.key}.title`) }}
</button>

</div>

<transition name="fade">
  <div v-if="selectedCategory" class="skill-card mx-auto">
    <div class="d-flex align-items-center gap-3 mb-2">
      <Icon
        :icon="categoryList.find(c => c.key === selectedCategory).icon"
        class="icon"
        width="28"
        height="28"
      />
      <h5 class="mb-0 text-white">
        {{ $t(`home.categories.${selectedCategory}.title`) }}
      </h5>
    </div>

    <div class="d-flex flex-wrap justify-content-center gap-2 mt-3">
      <span
        v-for="tech in categoryList.find(c => c.key === selectedCategory).tech"
        :key="tech"
        class="tech-badge"
      >
        <Icon :icon="techIcons[tech]" width="20" height="20" class="me-1" />
        {{ $t(`home.tech.${tech}`) }}
      </span>
    </div>
    <p class="text-white small mb-4 mt-4">
      {{ $t(`home.categories.${selectedCategory}.desc`) }}
    </p>

  </div>
</transition>


  </div>
</template>
<script setup>
import { ref } from 'vue'
import { Icon } from '@iconify/vue'
const techIcons = {
  vue: 'simple-icons:vuejs',
  django: 'simple-icons:django',
  javascript: 'simple-icons:javascript',
  php: 'simple-icons:php',
  wordpress: 'simple-icons:wordpress',
  html: 'simple-icons:html5',
  python: 'simple-icons:python',
  r: 'simple-icons:r',
  cpp: 'simple-icons:cplusplus',
  linux: 'simple-icons:linux',
  lua: 'simple-icons:lua',
  bash: 'simple-icons:gnubash',
  godot: 'simple-icons:godotengine',
  gdscript: 'simple-icons:godotengine',
  blender: 'simple-icons:blender',
  pandas: 'simple-icons:pandas',
  sklearn: 'simple-icons:scikitlearn',
  postgresql: 'simple-icons:postgresql',
  mongodb: 'simple-icons:mongodb',
  mysql: 'simple-icons:mysql',
  excel: 'simple-icons:microsoftexcel',
  gimp: 'simple-icons:gimp',
  photoshop: 'simple-icons:adobephotoshop',
  clipchamp: 'mdi:video-box',
  canva: 'simple-icons:canva',
  eviews: 'mdi:chart-bell-curve'
}




import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const selectedCategory = ref(null)
const categoryList = [
  {
    key: 'web',
    title: t('home.categories.web.title'),
    icon: 'mdi:monitor',
    tech: ['django', 'php', 'javascript', 'html', 'wordpress', 'linux']
  },
  {
    key: 'software',
    title: t('home.categories.software.title'),
    icon: 'mdi:application-braces',
    tech: ['python', 'cpp', 'lua']
  },
  {
    key: 'game',
    title: t('home.categories.game.title'),
    icon: 'mdi:gamepad-variant',
    tech: ['godot', 'gdscript', 'blender']
  },
  {
    key: 'data',
    title: t('home.categories.data.title'),
    icon: 'mdi:chart-line',
    tech: ['pandas', 'r', 'sklearn', 'excel', 'eviews']
  },
  {
    key: 'marketing',
    title: t('home.categories.marketing.title'),
    icon: 'mdi:bullhorn-variant',
    tech: ['gimp', 'photoshop', 'clipchamp', 'canva']
  },
  {
    key: 'databases',
    title: t('home.categories.databases.title'),
    icon: 'mdi:database',
    tech: ['mongodb', 'postgresql', 'mysql']
  }
]



</script>

<style scoped>
.text-primary {
  color: #00ffcc !important;
}
.btn-outline-primary {
  position: relative;
  color: #00ffcc !important;
  border: 2px solid #00ffcc;
  background-color: transparent;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 0 8px transparent;
}
.skills-container {
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(20px);
}
.btn-outline-primary:hover {
  color: #fff !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}
.btn-outline-primary.active {
  color: #111 !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}
.btn-outline-primary:disabled {
  color: #fff !important;
  border-color: #00a584;
  transform: translateY(-2px);
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.typing-title {
  overflow: hidden;
  white-space: nowrap;
  border-right: 2px solid #00ffcc;
  width: fit-content;
  margin: 0 auto;
  animation: typing 2s steps(32) 1s forwards, blink 0.75s step-end infinite;
  font-family: 'Fira Code', monospace;
}

@keyframes typing {
  from { width: 0 }
  to { width: 250px }
}
@keyframes blink {
  50% { border-color: transparent }
}

.badge {
  padding: 0.6em 1em;
  font-size: 0.85rem;
  border-radius: 100px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.5px;
  box-shadow: 0 0 6px rgba(0, 255, 204, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid #00ffcc;
  font-family: 'Fira Code', monospace;
}

.badge:hover {
  transform: scale(1.05);
  box-shadow: 0 0 12px rgba(0, 255, 204, 0.5);
}

.skill-card {
  max-width: 800px;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.65);
  border: 1px solid #00ffcc;
  border-radius: 12px;
  animation: fadeInCard 0.5s ease;
  box-shadow: 0 0 20px #00ffcc22;
}

.skill-card h5 {
  font-size: 1.25rem;
  font-family: 'Fira Code', monospace;
}

.skill-card p {
  font-size: 0.95rem;
}

.tech-badge {
  background: #111;
  color: white;
  border: 1px solid #00ffcc;
  border-radius: 50px;
  padding: 0.4em 0.8em;
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  font-size: 0.85rem;
  font-family: 'Fira Code', monospace;
  box-shadow: 0 0 6px #00ffcc33;
  transition: all 0.2s ease;
}

.tech-badge:hover {
  background: #00ffcc33;
  transform: scale(1.05);
  box-shadow: 0 0 12px #00ffcc66;
}


.skill-card {
  max-width: 800px;
  padding: 1.2rem;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid #00ffcc;
  border-radius: 10px;
  animation: fadeInCard 0.5s ease;
}

.icon {
  color: #00ffcc;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes fadeInCard {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>